import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-swap-type-selector',
  templateUrl: './swap-type-selector.component.html'
})
export class SwapTypeSelectorComponent {

  @Input()
  selectedTenorId: any;

  @Input()
  tenors: any[];

  @Output()
  swapTypeChanged = new EventEmitter();

  emitChange(swap) {
    this.swapTypeChanged.emit(swap);
  }
}
